{
    "ComparisonTypeLabel": "When:",
    "ComparisonTypeOptionNone": "[No Alarm]",
    "ComparisonTypeOptionHigherThan": "Higher Than",
    "ComparisonTypeOptionHigherEqual": "Higher/Equal",
    "ComparisonTypeOptionLowerThan": "Lower Than",
    "ComparisonTypeOptionLowerEqual": "Lower/Equal",
    "ComparisonTypeOptionBetween": "Between",
    "ComparisonTypeOptionEqual": "Equal",
    "ComparisonTypeOptionNotEqual": "Not Equal",
    "ComparisonTypeOptionNotBetween": "Not Between",
    "ComparisonTypeValue": "Value:",
    "ComparisonTypeAnd": "And",
    "AlarmTypeLabel": "Alarm Type:",
    "AlarmTypeNoSound": "[No Sound]",
    "AlarmType_Air Raid Siren": "Air Raid Siren",
    "AlarmType_Alarm Clock": "Alarm Clock",
    "AlarmType_Barking": "Barking",
    "AlarmType_Birds": "Birds",
    "AlarmType_Cat": "Cat",
    "AlarmType_Chips": "Chips",
    "AlarmType_Coin Drop": "Coin Drop",
    "AlarmType_Computer": "Computer",
    "AlarmType_Cow": "Cow",
    "AlarmType_Crowd": "Crowd",
    "AlarmType_Dial Tone": "Dial Tone",
    "AlarmType_Ding": "Ding",
    "AlarmType_Dixie Horn": "Dixie Horn",
    "AlarmType_Door Chime": "Door Chime",
    "AlarmType_Emergency Services": "Emergency Services",
    "AlarmType_Fasten Seat Belt": "Fasten Seat Belt",
    "AlarmType_Fire Truck": "Fire Truck",
    "AlarmType_Gunshot": "Gunshot",
    "AlarmType_Hammer": "Hammer",
    "AlarmType_Helicopter": "Helicopter",
    "AlarmType_Ice Cubes": "Ice Cubes",
    "AlarmType_Kerching": "Kerching",
    "AlarmType_Laughter": "Laughter",
    "AlarmType_Marbles": "Marbles",
    "AlarmType_Monkey": "Monkey",
    "AlarmType_Morse Code": "Morse Code",
    "AlarmType_Night Time": "Night Time",
    "AlarmType_Owl": "Owl",
    "AlarmType_Phone": "Phone",
    "AlarmType_Pool": "Pool",
    "AlarmType_Pouring Water": "Pouring Water",
    "AlarmType_Quick Bleep": "Quick Bleep",
    "AlarmType_Radar": "Radar",
    "AlarmType_Reload": "Reload",
    "AlarmType_Rocks Falling": "Rocks Falling",
    "AlarmType_Rooster": "Rooster",
    "AlarmType_Sawing": "Sawing",
    "AlarmType_School Bell": "School Bell",
    "AlarmType_Seaguls": "Seaguls",
    "AlarmType_Service Bell": "Service Bell",
    "AlarmType_SMS": "SMS",
    "AlarmType_Sonar Ping": "Sonar Ping",
    "AlarmType_Splash": "Splash",
    "AlarmType_Steam Train": "Steam Train",
    "AlarmType_Submarine": "Submarine",
    "AlarmType_Target": "Target",
    "AlarmType_Thunder": "Thunder",
    "AlarmType_Ting": "Ting",
    "AlarmType_Tolling Bell": "Tolling Bell",
    "AlarmType_Trombone": "Trombone",
    "AlarmType_Twinkle": "Twinkle",
    "AlarmType_Walking": "Walking",
    "AlarmType_Whistling": "Whistling",
    "AlarmType_Warning Beep": "Warning Beep",
    "AlarmType_Warning Buzzer": "Warning Buzzer",
    "AlarmRepeatTypeLabel": "Playback Type:",
    "AlarmRepeatOnce": "Once",
    "AlarmRepeatSeconds": "Seconds",
    "AlarmRepeatPersistent": "Persistent",
    "AlarmRepeatRepeat": "Repeat",
    "AlarmSettingsLabel": "Value:",
    "NAME": "StatisticAlarm",
    "StatisticAlarm_SectionHeader": "Statistic Alarm"
}
